var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nvs-create"},[_c('ul',_vm._l((_vm.options),function(option,idx){return _c('li',{key:idx},[_c('app-form-radio',{staticClass:"single-radio"}),_c('app-heading',{style:({'color': _vm.colors.splashColor}),attrs:{"level":"h6"}},[_vm._v(_vm._s(option.label))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }